import { render, staticRenderFns } from "./AuthIFrame.vue?vue&type=template&id=66c6b6e1&"
import script from "./AuthIFrame.vue?vue&type=script&lang=js&"
export * from "./AuthIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports